import Axios from "axios";
import { handleError } from "../../utils/utils";

export async function getProductsByCategory(
  categoryId: number,
  includeInactive = false
) {
  try {
    const products = await Axios.get(
      `/v2/products/category/${categoryId}/products`,
      { params: includeInactive ? { includeInactive: true } : undefined }
    );
    return products.data;
  } catch (error) {
    handleError(error);
  }
}
